import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {Mutex} from 'async-mutex'
import {EndpointNameAuth} from '../constants/endpoints'
import {useStorage} from '../utils/storage'
import {RTKTagNames} from '../constants/rtk-tag-names'
const API_URL = process.env.REACT_APP_BACKEND_URL
export const baseUrl = `${API_URL}/api/v1`

const mutex = new Mutex()

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: headers => {
    const accessToken = useStorage.getTokens().access?.split(' ')[1]
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`)
    }
    headers.set('Accept', 'application/json')
    return headers
  },
})

const customFetchBase = async (args, api, extraOptions) => {
  await mutex.waitForUnlock()

  let result = await baseQuery(args, api, extraOptions)

  if (result.error?.status === 401 && result.error?.data?.detail !== 'No active account found with the given credentials') {
    const tokens = useStorage.getTokens()
    const refreshToken = tokens.refresh?.split(' ')[1] || tokens.refresh

    if (refreshToken) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()

        try {
          const refreshResult = await baseQuery(
            {
              url: EndpointNameAuth.REFRESH_TOKEN,
              body: {
                refresh: refreshToken,
              },
              method: 'POST',
            },
            api,
            extraOptions,
          )

          if (refreshResult.data) {
            useStorage.setCredentials({
              access: refreshResult.data.access,
              refresh: refreshResult.data.refresh || refreshToken,
              role: useStorage.getRole(),
            })
            result = await baseQuery(args, api, extraOptions)
          } else {
            localStorage.clear()
            window.location.href = '/login'
          }
        } catch (err) {
          localStorage.clear()
          window.location.href = '/login'
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
    } else {
      localStorage.clear()
      window.location.href = '/login'
    }

    if (result.error?.status === 401 && result.error?.data?.detail !== 'No active account found with the given credentials') {
      localStorage.clear()
      window.location.href = '/login'
    }
  }

  return result
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: customFetchBase,
  tagTypes: Object.values(RTKTagNames),
  endpoints: () => ({}),
})
